import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { Button, Form, Alert, Dropdown, DropdownButton } from 'react-bootstrap';
import md5 from 'md5-hash';
import { useNavigate } from "react-router-dom";
import { Stage, Layer, Image } from 'react-konva';
import useImage from 'use-image';
import { C4FStatusContext } from "../main/App";

import TrikotBaseSimple from "../img/teamjerseys/trikot_base_simple.png";

import JerseyApricot from "../img/teamjerseys/jersey_apricot.png";
import JerseyBurgundy from "../img/teamjerseys/jersey_burgundy.png";
import JerseyCharcoal from "../img/teamjerseys/jersey_charcoal.png";
import JerseyChocolate from "../img/teamjerseys/jersey_chocolate.png";
import JerseyEbony from "../img/teamjerseys/jersey_ebony.png";
import JerseyIvory from "../img/teamjerseys/jersey_ivory.png";
import JerseyLavender from "../img/teamjerseys/jersey_lavender.png";
import JerseyMint from "../img/teamjerseys/jersey_mint.png";
import JerseyNavy from "../img/teamjerseys/jersey_navy.png";
import JerseySky from "../img/teamjerseys/jersey_sky.png";

import BibApricot from "../img/teamjerseys/bib_apricot.png";
import BibBurgundy from "../img/teamjerseys/bib_burgundy.png";
import BibCharcoal from "../img/teamjerseys/bib_charcoal.png";
import BibChocolate from "../img/teamjerseys/bib_chocolate.png";
import BibEbony from "../img/teamjerseys/bib_ebony.png";
import BibIvory from "../img/teamjerseys/bib_ivory.png";
import BibLavender from "../img/teamjerseys/bib_lavender.png";
import BibMint from "../img/teamjerseys/bib_mint.png";
import BibNavy from "../img/teamjerseys/bib_navy.png";
import BibSky from "../img/teamjerseys/bib_sky.png";

import BikeApricot from "../img/teamjerseys/bike_apricot.png";
import BikeBurgundy from "../img/teamjerseys/bike_burgundy.png";
import BikeCharcoal from "../img/teamjerseys/bike_charcoal.png";
import BikeChocolate from "../img/teamjerseys/bike_chocolate.png";
import BikeEbony from "../img/teamjerseys/bike_ebony.png";
import BikeIvory from "../img/teamjerseys/bike_ivory.png";
import BikeLavender from "../img/teamjerseys/bike_lavender.png";
import BikeMint from "../img/teamjerseys/bike_mint.png";
import BikeNavy from "../img/teamjerseys/bike_navy.png";
import BikeSky from "../img/teamjerseys/bike_sky.png";
import { validateUserName } from "../common/Helpers";

function Signup() {

  const navigate = useNavigate();

  const { handleBackendRequest, raiseError } = useContext(C4FStatusContext);
  const [userCreated, setUserCreated] = useState(false);
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmedPassword, setConfirmedPassword] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [signupInfo, setSignupInfo] = useState('');
  const [language, setLanguage] = useState('English');
  const [jerseyColor, setJerseyColor] = useState('burgundy');
  const [jersey, setJersey] = useState(JerseyBurgundy);
  const [bibColor, setBibColor] = useState('ebony');
  const [bib, setBib] = useState(BibEbony);
  const [bikeColor, setBikeColor] = useState('charcoal');
  const [bike, setBike] = useState(BikeCharcoal);

  const RiderImage = props => {
    const [image] = useImage(props.url);
    return <>
      <Image
        image={image} x={props.x} y={props.y}
        width={props.width} height={props.height}
      />
    </>;
  };

  function handleJerseyColor(newColor) {
    setJerseyColor(newColor);
    if (newColor === 'apricot') {
      setJersey(JerseyApricot);
    }
    else if (newColor === 'burgundy') {
      setJersey(JerseyBurgundy);
    }
    else if (newColor === 'charcoal') {
      setJersey(JerseyCharcoal);
    }
    else if (newColor === 'chocolate') {
      setJersey(JerseyChocolate);
    }
    else if (newColor === 'ebony') {
      setJersey(JerseyEbony);
    }
    else if (newColor === 'ivory') {
      setJersey(JerseyIvory);
    }
    else if (newColor === 'lavender') {
      setJersey(JerseyLavender);
    }
    else if (newColor === 'mint') {
      setJersey(JerseyMint);
    }
    else if (newColor === 'navy') {
      setJersey(JerseyNavy);
    }
    else if (newColor === 'sky') {
      setJersey(JerseySky);
    }
  }

  function handleBibColor(newColor) {
    setBibColor(newColor);
    if (newColor === 'apricot') {
      setBib(BibApricot);
    }
    else if (newColor === 'burgundy') {
      setBib(BibBurgundy);
    }
    else if (newColor === 'charcoal') {
      setBib(BibCharcoal);
    }
    else if (newColor === 'chocolate') {
      setBib(BibChocolate);
    }
    else if (newColor === 'ebony') {
      setBib(BibEbony);
    }
    else if (newColor === 'ivory') {
      setBib(BibIvory);
    }
    else if (newColor === 'lavender') {
      setBib(BibLavender);
    }
    else if (newColor === 'mint') {
      setBib(BibMint);
    }
    else if (newColor === 'navy') {
      setBib(BibNavy);
    }
    else if (newColor === 'sky') {
      setBib(BibSky);
    }
  }

  function handleBikeColor(newColor) {
    setBikeColor(newColor);
    if (newColor === 'apricot') {
      setBike(BikeApricot);
    }
    else if (newColor === 'burgundy') {
      setBike(BikeBurgundy);
    }
    else if (newColor === 'charcoal') {
      setBike(BikeCharcoal);
    }
    else if (newColor === 'chocolate') {
      setBike(BikeChocolate);
    }
    else if (newColor === 'ebony') {
      setBike(BikeEbony);
    }
    else if (newColor === 'ivory') {
      setBike(BikeIvory);
    }
    else if (newColor === 'lavender') {
      setBike(BikeLavender);
    }
    else if (newColor === 'mint') {
      setBike(BikeMint);
    }
    else if (newColor === 'navy') {
      setBike(BikeNavy);
    }
    else if (newColor === 'sky') {
      setBike(BikeSky);
    }
  }

  function handleSubmit() {
    let validationResult = validateUserName(userName);
    if (!validationResult.result) {
      raiseError('Signup Error', 0, validationResult.message);
      return;
    }

    if (password === '' || userName === '' || emailAddress === '') {
      raiseError('Signup Error', 0, 'Username, password and email address need to be provided.');
      return;
    }

    if (password !== confirmedPassword) {
      raiseError('Signup Error', 0, 'Passwords don\'t match.');
      return;
    }

    if (!userName.match(/^[0-9a-zA-Z\s]+$/)) {
      raiseError('Signup Error', 0, 'Please provide a valid user name. Only letters, whitespaces and numbers are allowed. Leading and trailing whitespaces will be removed');
      return;
    }

    if (!emailAddress.toLowerCase()
      .match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)) {
      raiseError('Signup Error', 0, 'Please provide a valid email address.');
      return;
    }

    let languageISOCode = 'EN';
    switch (language) {
      case 'Dutch': languageISOCode = 'NL';break;
      case 'French': languageISOCode = 'FR';break;
      case 'German': languageISOCode = 'DE';break;
      case 'Italian': languageISOCode = 'IT';break;
      case 'Polish': languageISOCode = 'PL';break;
      case 'Portuguese': languageISOCode = 'PT';break;
      case 'Romanian': languageISOCode = 'RO';break;
      case 'Spanish': languageISOCode = 'ES';break;
    }

    const payload = {
      userName: userName.trim(),
      password: md5(password),
      emailAddress: emailAddress.trim().toLowerCase(),
      language: languageISOCode,
      country: languageISOCode,
      team: {
        balance: 20000000,
        jerseyColor: jerseyColor,
        bibColor: bibColor,
        bikeColor: bikeColor
      }
    }

    handleBackendRequest('POST', '/user/' + userName.trim(), payload, null,
      function () {
        setSignupInfo('User "' + userName.trim() + '" created.');
        setUserCreated(true);
      });
  }

  function handleSetUserName(userName) {
    let validationResult = validateUserName(userName);
    setSignupInfo(validationResult.result ? null : validationResult.message);
    setUserName(userName);
  }

  return <div className="container-fluid m-3">
    <div className="row d-flex justify-content-center">
      <div className="col" style={{ minWidth: 300, maxWidth: 600, backgroundColor: 'rgba(245, 250, 255, 1)' }}>
        <h4>Create a new Team</h4>
        <Alert className="mt-1" key="oneaccountalert" variant={'warning'}>Only forgot your password? Reset your password <Link to="/login">here</Link>.</Alert>
        <table className="table table-sm align-middle text-left">
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><b>Team Jersey</b><br />Can be changed later in profile.<br />
                <Stage width={120} height={120}>
                  <Layer>
                    <RiderImage
                      url={TrikotBaseSimple}
                      x={0} y={0}
                      width={120} height={120}
                    />
                    <RiderImage
                      url={bib}
                      x={0} y={0}
                      width={120} height={120}
                    />
                    <RiderImage
                      url={jersey}
                      x={0} y={0}
                      width={120} height={120}
                    />
                    <RiderImage
                      url={bike}
                      x={0} y={0}
                      width={120} height={120}
                    />
                  </Layer>
                </Stage>
              </td>
              <td>

                <div><b>Jersey</b>
                  <DropdownButton variant="outline-secondary py-0 my-1" title={jerseyColor}
                    onSelect={(newJerseyColor, e) => handleJerseyColor(newJerseyColor)}>
                    {['apricot', 'burgundy', 'charcoal', 'chocolate', 'ebony', 'ivory', 'lavender', 'mint', 'navy', 'sky'].map((jerseyColor) => (
                      <Dropdown.Item eventKey={jerseyColor}>{jerseyColor}</Dropdown.Item>
                    )
                    )}
                  </DropdownButton>
                </div>
                <b>Bib Short</b>
                <DropdownButton variant="outline-secondary py-0 my-1" title={bibColor}
                  onSelect={(newBibColor, e) => handleBibColor(newBibColor)}>
                  {['apricot', 'burgundy', 'charcoal', 'chocolate', 'ebony', 'ivory', 'lavender', 'mint', 'navy', 'sky'].map((bibColor) => (
                    <Dropdown.Item eventKey={bibColor}>{bibColor}</Dropdown.Item>
                  )
                  )}
                </DropdownButton>
                <b>Bike Frame</b>
                <DropdownButton variant="outline-secondary py-0 my-1" title={bikeColor}
                  onSelect={(newBikeColor, e) => handleBikeColor(newBikeColor)}>
                  {['apricot', 'burgundy', 'charcoal', 'chocolate', 'ebony', 'ivory', 'lavender', 'mint', 'navy', 'sky'].map((bikeColor) => (
                    <Dropdown.Item eventKey={bikeColor}>{bikeColor}</Dropdown.Item>
                  )
                  )}
                </DropdownButton>
              </td>
            </tr>
            <tr>
              <td><b>Team Name</b></td>
              <td><Form.Control
                onChange={(e) => handleSetUserName(e.target.value)}
                placeholder="team name"
                value={userName} />
              </td>
            </tr>
            <tr>
              <td><b>Password</b></td>
              <td><Form.Control
                onChange={(e) => setPassword(e.target.value)}
                placeholder="password"
                type="password"
                value={password} />
              </td>
            </tr>
            <tr>
              <td><b>Confirm Password</b></td>
              <td><Form.Control
                onChange={(e) => setConfirmedPassword(e.target.value)}
                placeholder="confirm password"
                type="password"
                value={confirmedPassword} />
              </td>
            </tr>
            <tr>
              <td><b>E-Mail Address</b></td>
              <td><Form.Control
                onChange={(e) => setEmailAddress(e.target.value)}
                placeholder="email address"
                value={emailAddress} />
              </td>
            </tr>
            <tr>
              <td><b>Language</b></td>
              <td><DropdownButton variant="outline-secondary py-0 my-1" title={language}
                onSelect={(newLanguage, e) => setLanguage(newLanguage)}>
                {['Dutch', 'English', 'French', 'German', 'Italian', 'Polish', 'Portuguese', 'Romanian', 'Spanish'].map((language) => (
                  <Dropdown.Item eventKey={language}>{language}</Dropdown.Item>
                )
                )}
              </DropdownButton>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                {userCreated ?
                  <Button type="button" variant="primary" onClick={(e) => navigate('/login')}>Login Now</Button>
                  :
                  <Button type="button" variant="success" disabled={signupInfo} onClick={(e) => handleSubmit()}>Create Team</Button>
                }
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                {userCreated ?
                  <Alert className="m-1" key="alertsignup" variant={'success'}>{signupInfo}</Alert>
                  :
                  <Alert className="m-1" key="alertsignup" variant={'danger'}>{signupInfo}</Alert>
                }
              </td>
            </tr>
          </tbody>
        </table>
        <br />
      </div>
    </div>
  </div>

}

export default Signup;